
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const target = document.querySelector('[data-main-product-image]');
      if (target) {
        target.src = thumb.dataset.full || thumb.src;
        target.srcset = '';
      }
    });
  });
});
